import { render } from "./InputTelefone.vue?vue&type=template&id=49666afd"
import script from "./InputTelefone.vue?vue&type=script&lang=js"
export * from "./InputTelefone.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__